/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from '@msdyn365-commerce-modules/business-account-management';
import { IVinhusetBusinessSignUpResources } from './vinhuset-business-sign-up.props.autogenerated';
import BusinessSignUpItemDepartment from '../../themes/vinhuset-adventureworks/views/components/business-sign-up-item.department';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem & { resources: IVinhusetBusinessSignUpResources }> = ({ wrapper, label, errorMessage, input, isAddressInput, resources }) => {
    const reactLabel = label as React.ReactElement | undefined;

    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && (reactLabel?.props.id === 'Department'
                ? React.cloneElement(reactLabel, { text: resources.organizationIdLabel })
                : label)}
            {!isAddressInput && errorMessage}
            {input}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps & { resources: IVinhusetBusinessSignUpResources }> = props => {
    const { businessSignUp, ContainerWrapper, heading, businessSignUpForm } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            switch (item.id) {
                                case 'Department':
                                    return (
                                        <BusinessSignUpItemDepartment
                                            key={item.id}
                                            context={props.businessSignUp.moduleProps.context}
                                            {...item}
                                            {...props}
                                            inputId={item.id}
                                        />
                                    );
                                default:
                                    return (
                                        <BusinessSignUpItem
                                            key={item.id}
                                            {...item}
                                            {...props}
                                        />
                                    );
                            }
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
